var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMdpRequirementsNo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 617"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 15,
    fill: "#E4E0D8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.2987 8.70173C21.552 8.95509 21.552 9.36585 21.2987 9.6192L9.62116 21.2967C9.3678 21.5501 8.95704 21.5501 8.70369 21.2967C8.45033 21.0434 8.45033 20.6326 8.70369 20.3792L20.3812 8.70173C20.6345 8.44838 21.0453 8.44838 21.2987 8.70173Z",
    fill: "#908F8E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.70369 8.70173C8.95704 8.44838 9.3678 8.44838 9.62116 8.70173L21.2987 20.3792C21.552 20.6326 21.552 21.0434 21.2987 21.2967C21.0453 21.5501 20.6345 21.5501 20.3812 21.2967L8.70369 9.6192C8.45033 9.36585 8.45033 8.95509 8.70369 8.70173Z",
    fill: "#908F8E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMdpRequirementsNo);
export default __webpack_public_path__ + "static/media/mdp-requirements-no.67cbca2f36c164a51b7ae62c62d3ff93.svg";
export { ForwardRef as ReactComponent };